import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import CircularLoader from "../CircularLoader";

const LoaderWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 50%;
  margin-bottom: 50%;
  justify-content: center;
  align-items: center;
`;

export default class LoadingBlock extends PureComponent<{}> {
  public render(): ReactNode {
    return (
      <LoaderWrapper>
        <CircularLoader />
      </LoaderWrapper>
    );
  }
}
